"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MPFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_155)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_155`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#0071BC"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 22.56C17.9646 22.56 22.8 17.7246 22.8 11.76C22.8 5.79529 17.9646 0.959961 12 0.959961C6.03528 0.959961 1.19995 5.79529 1.19995 11.76C1.19995 17.7246 6.03528 22.56 12 22.56Z",
					fill: "white",
					stroke: "black",
					strokeWidth: .0912
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9998 19.6801C16.3739 19.6801 19.9198 16.1342 19.9198 11.7601C19.9198 7.38599 16.3739 3.84009 11.9998 3.84009C7.62574 3.84009 4.07983 7.38599 4.07983 11.7601C4.07983 16.1342 7.62574 19.6801 11.9998 19.6801Z",
					fill: "#0071BC",
					stroke: "black",
					strokeWidth: .0912
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.3457 21.6C15.3793 22.128 14.9713 22.56 14.4433 22.56H9.53288C9.00488 22.56 8.59688 22.128 8.62088 21.6L9.42248 6.00004C9.45128 5.47204 9.90248 5.04004 10.4305 5.04004H13.3777C13.9057 5.04004 14.3617 5.47204 14.3953 6.00004L15.3457 21.6Z",
					fill: "#8C8A8C",
					stroke: "black",
					strokeWidth: .0912
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9041 5.47192L13.3441 9.93592H18.0001L14.2561 12.6239L15.6481 17.0399L11.9041 14.3519L8.16011 17.0879L9.60011 12.6239L5.80811 9.88792H10.4641L11.9041 5.47192Z",
					fill: "white",
					stroke: "black",
					strokeWidth: .096,
					strokeLinejoin: "round"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_155`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MPFlag };
